<button *ngIf="buffer.length > 0" climbButton size="md" variant="primary" [popoverTriggerFor]="copy.popover">
    <svg [climbIcon]="icons.squareOnSquare" size="sm"></svg>
</button>

<climb-copy-buffer-popover #copy></climb-copy-buffer-popover>
